// extracted by mini-css-extract-plugin
module.exports = {"header":"Layout_header__2Ep86","left":"Layout_left__5adsb","right":"Layout_right__6yTLT","logo":"Layout_logo__jTZHp","userName":"Layout_userName__39v0g"};